import OpenAI from "openai"
import { isBrowser } from "@/lib/agents/isbrowser"
import { imagePrompt } from "./prompts"
import { chunkText, uploadFile } from "./utils"


export async function extractImages(file: File, apiKey: string): Promise<ExtractedDocument> {

  const ext: ExtractedDocument = {
    locale: "",
    text: "",
    chunks: [],
  }
  const client = new OpenAI({ apiKey, dangerouslyAllowBrowser: true, baseURL: isBrowser ? "https://signpost-ia-app-qa.azurewebsites.net/decorsify/https://api.openai.com/v1" : undefined })


  // const buffer = Buffer.from(await file.arrayBuffer())

  const base64Image = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const base64 = (reader.result as string).split(',')[1]
      resolve(base64)
    }
    reader.onerror = reject
    reader.readAsDataURL(file)
  })

  const fileName = file.name.toLowerCase()

  let mimeType = 'image/jpeg' // default
  if (fileName.endsWith('.png')) {
    mimeType = 'image/png'
  } else if (fileName.endsWith('.webp')) {
    mimeType = 'image/webp'
  } else if (fileName.endsWith('.gif')) {
    mimeType = 'image/gif'
  }

  const response = await client.chat.completions.create({
    model: 'gpt-4o-mini',
    messages: [
      {
        role: 'user',
        content: [
          {
            type: 'text',
            text: imagePrompt,
          },
          {
            type: 'image_url',
            image_url: {
              url: `data:${mimeType};base64,${base64Image}`,
            },
          },
        ],
      },
    ],
    max_tokens: 1000,
  })


  ext.text = response.choices[0].message.content
  ext.chunks = await chunkText(ext.text)

  return ext
}
